
  export const devices_statuses = {
      methods: {
        getStatusName: function (status) {
            if(status == 0){
                return 'dev_stat_new';
            }else if(status == 1){
                 return 'dev_stat_agreed'
            }else if(status == 2){
                 return 'dev_stat_in_production'
            }else if(status == 3){
                 return 'dev_stat_production'
            } else if(status == 4){
                 return 'dev_stat_in_repair'
            } else if(status == 5){
                 return 'dev_stat_deleted'
            } else if(status == 6){
                 return 'dev_stat_order'
            }else{
                return ''
            } 
            
        },
    }
  }


